import { TAGS } from "../constants";
import {
  DeepPartial,
  GetPatientProfilesArgs,
  PatientCoupon,
  PatientProfile,
  PaymentMethodType,
} from "../types";
import { api } from "./api";

export const patientApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPatientProfiles: builder.query<
      {
        data: PatientProfile[];
        count: number;
      },
      GetPatientProfilesArgs
    >({
      query: (params) => ({
        method: "GET",
        url: "/api/patients",
        params,
      }),
    }),
    getPatientById: builder.query<PatientProfile, number>({
      query: (patientId) => ({
        method: "GET",
        url: `/api/patients/${patientId}`,
      }),
      providesTags: (_returns, _error, args) => [
        { type: TAGS.PATIENT, id: args },
      ],
    }),

    updatePatient: builder.mutation<
      PatientProfile,
      DeepPartial<PatientProfile>
    >({
      query: ({ profile_id, ...body }) => ({
        url: `/api/patients/${profile_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_returns, _error, args) => [
        {
          type: TAGS.PATIENT,
          id: args.id,
        },
      ],
    }),
    getPatientPaymentMethods: builder.query<PaymentMethodType[], string>({
      query: (stripeId: string) => ({
        method: "GET",
        url: `/api/patients/payment-methods/${stripeId}`,
      }),
      providesTags: (_returns, _error, args) => [
        { type: TAGS.PAYMENT_METHODS, id: args },
      ],
    }),
    getPatientCoupons: builder.query<
      PatientCoupon[],
      {
        id: number;
        params?: {
          invoice_id?: string;
          redeemed?: boolean;
        };
      }
    >({
      query: ({ id, params }) => ({
        url: `/api/patients/${id}/coupons`,
        method: "GET",
        params,
      }),
      providesTags(_result, _error, arg) {
        return [{ type: TAGS.PATIENT_COUPONS, id: arg.id }];
      },
    }),
  }),
});

export const {
  useGetPatientByIdQuery,
  useGetPatientProfilesQuery,
  useUpdatePatientMutation,
  useGetPatientPaymentMethodsQuery,
  useGetPatientCouponsQuery,
} = patientApi;
